import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('@modules/auth/auth-routing.module').then(
        (m) => m.AuthRoutingModule
      ),
  },
  {
    path: '',
    loadChildren: () =>
      import('@modules/flights/flights-routing.module').then(
        (m) => m.FlightsRoutingModule
      ),
  },
];
